module.exports = __webpack_public_path__ + "static/img/partner-logo3.87e7d5a8.jpg";